import React, { useEffect, useState, useId } from 'react';
import '/app/frontend/stylesheets/admin/general_info.scss'
import CustomConfirm from "../Blocks/CustomConfirm";

const statusChange = (props) => {
  const [open, setOpen] = useState(false);
  const [assessor, setAssessor] = useState(false);
  const userRole = props.user_role;
  const { status, url, destroy_url, styles } = props;
  const randomId = useId();

  const VerifiedButtonHTML = () => {
    return `
      <a rel="nofollow" data-method="put" href="${url}?status=verified" style="display: -webkit-box;">
        <div class="verified-img"></div>
        <span class="text">Verify</span>
      </a>
    `;
  };

  const RejectedButtonHTML = () => {
    return `
      <a rel="nofollow" data-method="put" href="${url}?status=rejected" style="display: -webkit-box;">
        <div class="invalid-img"></div>
        <span class="text">Reject</span>
      </a>
    `;
  };

  useEffect(() => {
    if (!open) {
      return
    }

    if (userRole === 'assessor') {
      setAssessor(true);
      return
    }

    if (status === 'Pending review') {
      document.getElementById(randomId).innerHTML = null;
      document.getElementById(randomId).innerHTML = RejectedButtonHTML() + '\n' + VerifiedButtonHTML();
    } else if (status === 'Verified') {
      document.getElementById(randomId).innerHTML = null;
      document.getElementById(randomId).innerHTML = RejectedButtonHTML();
    } else if (status === 'Rejected') {
      document.getElementById(randomId).innerHTML = null;
      document.getElementById(randomId).innerHTML = VerifiedButtonHTML();
    }
  }, [open]);

  return (
    <div>
      <div onClick={(() => setOpen(true))} className={`select-none ${styles.indicator}`} style={{display: (open ? 'none' : 'block')}}>
        <span className="font-bold">. . .</span>
      </div>
      <div className={`status -float-right ${styles.buttons}`} style={{display: (open ? 'block' : 'none')}}>
        <div id={randomId}>
          { assessor ? (
              <CustomConfirm
                url={`${url}?status=contacted`}
                request_method='put'
                message='Change status to "Contacted"?'
                title={'If you change status, you won\'t be able to return the status "Verified”, “Rejected”'}
                content='<div class="contacted-img"></div>'/>
            )
            : ''
          }
        </div>

        { !assessor ? (
            <CustomConfirm
                url={destroy_url}
                request_method='delete'
                message='Delete user from system?'
                title={"If you delete user, you won't be able to return the user"}
                content='<div class="destroy-img"></div>'
            />
          )
          : ''
        }
      </div>
    </div>
  );
};

export default statusChange;
